import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routerOptions } from './router-options';
import { routes } from 'src/app/app.routes';

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
